<template>
  <v-select
    :options="options"
    :reduce="option => option.value"
    :value="value"
    @input="setValue"
    :placeholder="$t('selects.areaSelectPlaceholder')"
    :multiple="false"
    :disabled="disabled"
  />
</template>

<script>
export default {
  name: 'ReportingAreaSelect',
  props: {
    value: { type: String },
    areas: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    options() {
      const mapped = this.areas?.map(area => ({
        value: area.uuid,
        label: area.name,
      }))
      const sorted = mapped?.sort((a, b) => a.label.localeCompare(b.label, this.$i18n.locale, { sensitivity: 'base' }))
      return sorted
    },
  },
  methods: {
    setValue(value) {
      this.$emit('input', value)
    },
  },
}
</script>
